import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"margin-top":"15px","height":"90vh"} }
const _hoisted_3 = {
  key: 0,
  style: {"margin-top":"55px","height":"80vh"},
  class: "w100 posRe ofs"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "fs24 ls1 mc centered fw600" }, "グループの詳細設定", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "w100 mt20" }
const _hoisted_7 = {
  class: "w40 fl",
  style: {"padding":"10px 20px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "centered" }, "公開プロフィールの設定", -1)
const _hoisted_9 = { class: "centered w100 pad15 mt15" }
const _hoisted_10 = { class: "centered" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fs12 w100 fw600" }, " 紹介文 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "リンクボタンを挿入", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "fs11" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb40" }, null, -1)
const _hoisted_21 = { class: "fs12 w100 fw600 mt20" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "担当者変数-1", -1)
const _hoisted_23 = { class: "fs11" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_25 = { class: "fs12 w100 fw600 mt20" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "fl" }, "担当者変数-2", -1)
const _hoisted_27 = { class: "fs11" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  class: "w45 fr posRe",
  style: {"padding":"20px 20px"}
}
const _hoisted_30 = { class: "w100" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "w100"
}
const _hoisted_33 = {
  for: "uploadText",
  class: "UploadImageButton centered pointer posRe fl ddgreyBg",
  style: {
                                    height: `100px`,
                                    width: `100px`,
                                }
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 fw600 whiteColor pad5`),
  style: {"margin-top":"30px"}
}, " 画像をアップロード ", -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_37 = { class: "" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", null, "イベントオーナー(書込カレンダー)の設定", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, "日程確定時にイベントオーナーとするカレンダーを指定できます。", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = {
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_42 = { class: "" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10" }, "返信先設定", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_47 = { class: "" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr10" }, "通知設定", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: `can_add_emails_auto_`,
  class: "fs13"
}, "登録したカレンダーに自動通知", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "w100 mt20",
  style: {"padding":"10px 20px"}
}
const _hoisted_53 = { class: "" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h4", null, "割り当て比率の設定", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = {
  class: "w100 mt20",
  style: {}
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("h4", null, "1日に行える最大イベント数", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "既存のスケジュールの数を含めた最大イベント数", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_64 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_65 = {
  class: "posAb w30 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  class: "posAb w70 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "設定", -1)
const _hoisted_70 = [
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_SelectableImage = _resolveComponent("SelectableImage")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "GroupProfileModal",
    "content-class": "rad10 with_white_bg ofs shadowContent modalWide noscroll posRe w100",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        class: "dismiss",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
          width: "50",
          height: "50"
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.mag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("section", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.rm.userInfo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["userImage blackbrownBg ofh centered mc", `centered w100`]),
                            style: {"width":"140px","height":"140px","border-radius":"50%"}
                          }, [
                            _createVNode(_component_UserIcon, {
                              ref: "UserIcon",
                              imageUrl: _ctx.imageUrl,
                              canEdit: true,
                              updateSelf: false,
                              width: 140,
                              class: "posAb",
                              onUploaded: _ctx.uploadedUserImage
                            }, null, 8, ["imageUrl", "onUploaded"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_11
                  ]),
                  _hoisted_12,
                  _createVNode(_component_MdTextfieldTag, {
                    name: "表示するチーム名/担当者名",
                    style: {"height":"56px","min-width":"100%"},
                    fieldStyle: "min-width:100%;",
                    class: "fl fs14",
                    value: _ctx.mag.team_name,
                    onInputValue: _ctx.inputTeamName
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _createElementVNode("label", {
                    class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround`),
                    style: {"width":"130px","padding":"4px 10px","margin-bottom":"5px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.insertLinkButton && _ctx.insertLinkButton(...args)))
                  }, _hoisted_18),
                  _createVNode(_component_TextareaTag, {
                    placeholder: "○○が担当いたします。マーケティング面でのご提案に強みがあります。",
                    class: "fl fs14 roundForm mw100",
                    value: _ctx.mag.description,
                    maxlength: 300,
                    style: {"height":"250px"},
                    onInputValue: _ctx.inputDescription
                  }, null, 8, ["value", "onInputValue"]),
                  _createElementVNode("span", _hoisted_19, "最大300文字です。 " + _toDisplayString(_ctx.mag.description ? _ctx.mag.description.length : 0) + " / 300 ", 1),
                  _hoisted_20,
                  _createElementVNode("label", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_IconHelp, {
                      width: 18,
                      class: "fl mr10",
                      tooltipText: `このグループが担当になった場合に、メールなどに変数を設定しておくことができます。`,
                      style: {"margin-top":"-3px"}
                    })
                  ]),
                  _createVNode(_component_TextareaTag, {
                    placeholder: "<<担当者変数-1>>として決まった際に利用できます。",
                    class: "fl fs14 roundForm mw100",
                    value: _ctx.mag.variable_1,
                    maxlength: 100,
                    onInputValue: _ctx.inputVariable1
                  }, null, 8, ["value", "onInputValue"]),
                  _createElementVNode("span", _hoisted_23, "最大100文字です。 " + _toDisplayString(_ctx.mag.variable_1 ? _ctx.mag.variable_1.length : 0) + " / 100 ", 1),
                  _hoisted_24,
                  _createElementVNode("label", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_IconHelp, {
                      width: 18,
                      class: "fl mr10",
                      tooltipText: `このグループが担当になった場合に、メールなどに変数を設定しておくことができます。`,
                      style: {"margin-top":"-3px"}
                    })
                  ]),
                  _createVNode(_component_TextareaTag, {
                    placeholder: "<<担当者変数-2>>として決まった際に利用できます。",
                    class: "fl fs14 roundForm mw100",
                    value: _ctx.mag.variable_2,
                    maxlength: 100,
                    onInputValue: _ctx.inputVariable2
                  }, null, 8, ["value", "onInputValue"]),
                  _createElementVNode("span", _hoisted_27, "最大100文字です。 " + _toDisplayString(_ctx.mag.variable_2 ? _ctx.mag.variable_2.length : 0) + " / 100 ", 1),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("section", _hoisted_30, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`w50 fl roomsCategoryTab posRe pointer centered ${
                                    _ctx.selectedTab == `group` ? `selected fw600` : ``
                                }`),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTab(`group`)))
                    }, " グループ設定 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(`w50 fl roomsCategoryTab posRe pointer centered ${
                                    _ctx.selectedTab == `image` ? `selected fw600` : ``
                                }`),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTab(`image`)))
                    }, " プロフィール画像選択 ", 2)
                  ]),
                  _hoisted_31,
                  (_ctx.selectedTab == `image`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("input", {
                            type: "file",
                            class: "drop__input",
                            style: {"display":"none"},
                            id: "uploadText",
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
                          }, null, 32)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFiles, (file, fileindex) => {
                          return (_openBlock(), _createBlock(_component_SelectableImage, {
                            key: fileindex,
                            file: file,
                            width: 100,
                            canDelete: true,
                            class: "ofh fl posRe",
                            onChange: _ctx.changeImage,
                            onMouseoverImage: _ctx.mouseoverImage,
                            onMouseleaveImage: _ctx.mouseleaveImage,
                            onDeleteImage: _ctx.deleteImage
                          }, null, 8, ["file", "onChange", "onMouseoverImage", "onMouseleaveImage", "onDeleteImage"]))
                        }), 128))
                      ]))
                    : (_ctx.selectedTab == `group`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _hoisted_38,
                              _hoisted_39,
                              _createVNode(_component_SelectTag, {
                                name: "additonal_connected_calendar",
                                id: "additonal_connected_calendar",
                                class: "fl fs14 roundForm w100",
                                style: {"min-width":"30px","height":"50px"},
                                options: _ctx.selectableCalendars(),
                                defaultOption: _ctx.defaultEventOwnerOption(),
                                onSelectValue: _ctx.selectEventOwner
                              }, null, 8, ["options", "defaultOption", "onSelectValue"])
                            ]),
                            _hoisted_40
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("h4", null, [
                                _hoisted_43,
                                _createVNode(_component_IconHelp, {
                                  width: 18,
                                  class: "fl mr10",
                                  tooltipText: `このグループが担当になった際に、送付するメールの返信先を設定できます。\nユーザー設定の返信先に入力している場合は、こちらが優先されます。`,
                                  style: {"margin-top":"-3px"}
                                })
                              ]),
                              _createVNode(_component_MdTextfieldTag, {
                                name: "返信するメールアドレス",
                                style: {"height":"56px","min-width":"100%"},
                                fieldStyle: "min-width:100%;",
                                class: "fl fs14 mb5",
                                value: _ctx.mag.reply_emails,
                                onInputValue: _ctx.inputReplyEmails,
                                required: ""
                              }, null, 8, ["value", "onInputValue"]),
                              _hoisted_44
                            ]),
                            _hoisted_45
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("h4", null, [
                                _hoisted_48,
                                _createVNode(_component_IconHelp, {
                                  width: 18,
                                  class: "fl mr10",
                                  tooltipText: `このグループが選択中に通知するメールアドレスを設定します。\nカンマ区切りで複数メールアドレスの指定が可能です。`,
                                  style: {"margin-top":"-3px"}
                                })
                              ]),
                              _createVNode(_component_MdTextfieldTag, {
                                name: "追加で通知するメールアドレス",
                                style: {"height":"56px","min-width":"100%"},
                                fieldStyle: "min-width:100%;",
                                class: "fl fs14 mb5",
                                value: _ctx.mag.emails,
                                onInputValue: _ctx.inputEmails,
                                required: ""
                              }, null, 8, ["value", "onInputValue"]),
                              _hoisted_49,
                              _createVNode(_component_CheckboxTag, {
                                value: ``,
                                name: `can_add_emails_auto`,
                                checked: _ctx.mag.can_add_emails_auto,
                                prefix: `can_add_emails_auto`,
                                onClickCheckbox: _ctx.clickAddEmailsAuto,
                                style: {"margin-left":"1px","margin-right":"7px"}
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_50
                            ]),
                            _hoisted_51
                          ]),
                          (
                                    _ctx.rcm &&
                                    _ctx.rcm.room_setting &&
                                    [`priority`, `priority_by_this_month`].includes(_ctx.rcm.room_setting.assign_mag_rule)
                                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createVNode(_component_MdTextfieldTag, {
                                    name: "割り当て比率 (0~100) ※ 0だと提案されません。",
                                    style: {"height":"56px","min-width":"100%"},
                                    fieldStyle: "min-width:100%;",
                                    class: "fl fs14 mb5",
                                    type: `number`,
                                    min: 0,
                                    max: 100,
                                    value: _ctx.mag.priority,
                                    onInputValue: _ctx.inputPriority
                                  }, null, 8, ["value", "onInputValue"]),
                                  _hoisted_55
                                ]),
                                _hoisted_56
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`w90 posRe rad20 pad20 ${_ctx.isActive ? `` : `yellowBg`}`)
                            }, [
                              _withDirectives(_createVNode(_component_Switcher, {
                                value: "type[is_active]",
                                name: "設定の有効",
                                checked: _ctx.isActive,
                                display: "true",
                                class: "checkUsingCal fr posAb",
                                style: {"transform":"scale(0.5)"},
                                onSelect: _ctx.changeActive
                              }, null, 8, ["checked", "onSelect"]), [
                                [_directive_tooltip, `設定を${_ctx.isActive ? `無効` : `有効`}にします`]
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(`${_ctx.isActive ? `` : `op4`}`)
                              }, [
                                _hoisted_58,
                                _hoisted_59,
                                _createVNode(_component_SelectTag, {
                                  name: "daily_meeting_max_num",
                                  id: "daily_meeting_max_num",
                                  class: "fl fs14 roundForm w100",
                                  style: {"min-width":"30px","height":"50px","max-width":"120px"},
                                  options: [
                                                `無制限`,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                                10,
                                                11,
                                                12,
                                                13,
                                                14,
                                                15,
                                                16,
                                                17,
                                                18,
                                                19,
                                                20,
                                            ],
                                  defaultOption: 
                                                _ctx.mag.daily_meeting_max_num == -1 ? `無制限` : _ctx.mag.daily_meeting_max_num
                                            ,
                                  onSelectValue: _ctx.selectDailyMeetingMaxNum
                                }, null, 8, ["defaultOption", "onSelectValue"]),
                                _hoisted_60,
                                _createVNode(_component_MdTextfieldTag, {
                                  name: "カウントする特定のキーワードを設定（未入力の場合、すべて対象）",
                                  style: {"height":"56px","min-width":"100%"},
                                  fieldStyle: "min-width:100%;",
                                  class: "fl fs14 mb5 mt40",
                                  value: _ctx.mag.daily_countable_event_keyword,
                                  onInputValue: _ctx.inputDailyCountableEventKeyword
                                }, null, 8, ["value", "onInputValue"])
                              ], 2),
                              _hoisted_61
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _hoisted_62
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("section", {
              class: "llgreyBg dgrey fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
            }, _hoisted_67)
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("section", {
              class: "w100 skyblueBg fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
            }, _hoisted_70)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}